/**
 * Modelo de Movimiento Intraday
 */
export interface CuentaBancoRef {
  id: string;
  nombre: string;
  tipo: 'PEN' | 'USD';
}

export interface MovimientoIntraday {
  id: string;
  monto: number;
  tipoCambio?: number;
  estado: 'CREADO' | 'REBOTADO' | 'CONCILIADO' | 'EN_CONCILIACION';
  fechaOperacion: string;
  comision?: number;
  cuentaCargo: CuentaBancoRef;
  cuentaDestino: CuentaBancoRef;
  fechaReprogramacion?: string;
  fechaEfectiva?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface MovimientoIntradayInput {
  monto: number;
  tipoCambio?: number;
  estado?: string;
  fechaOperacion: string;
  comision?: number;
  cuentaCargo: CuentaBancoRef;
  cuentaDestino: CuentaBancoRef;
}

export interface IncomeReconciliationIntradayCandidate {
  id: string;
  monto: number;
  tipoCambio?: number;
  estado: string;
  fechaOperacion: string;
  comision?: number;
  cuentaCargo: Pick<CuentaBancoRef, 'nombre' | 'tipo'>;
  cuentaDestino: Pick<CuentaBancoRef, 'nombre' | 'tipo'>;
}

export interface RealizarTransferenciaDialogData {
  ListaBancos: Array<{
    id?: string;
    nombre: string;
    descripcion?: string;
    tipo: string;
    saldo?: number;
  }>;
  cuentaCargo?: {
    id?: string;
    nombre: string;
    descripcion?: string;
    tipo: string;
    saldo?: number;
  } | null;
  lockCuentaCargo?: boolean;
}

export interface DetalleTransferenciaDialogData {
  id?: string;
  estado?: string;
  fechaOperacion?: string;
  cuentaCargo?: string;
  cuentaCargoTipo?: string;
  monto?: number;
  cuentaDestino?: string;
  cuentaDestinoTipo?: string;
  montoDestino?: number;
  tipoCambio?: number;
  comision?: number | null;
  fechaReprogramacion?: string | null;
  fechaEfectiva?: string | null;
}

export interface DialogResult {
  success: boolean;
  newTransferenciaBancaria: any;
}

